export enum PragmaCustomizedMountingType {
  AP = 'AP',
  UP = 'UP'
}

export enum PragmaCustomizedDoorType {
  PLAIN = 'Plain',
  VENTILATED = 'Ventilated',
  VENTILATED_WITH_MEDIA = 'Ventilated with Media'
}

export class PragmaConfiguration {
  mountingType: PragmaCustomizedMountingType;
  doorType: PragmaCustomizedDoorType;
  field: number;
  row: number;
  minRows?: number;
  minFields?: number;
  selectedCurrent: string;

  constructor() {
    this.mountingType = PragmaCustomizedMountingType.UP;
    this.doorType = PragmaCustomizedDoorType.PLAIN;
    this.field = 2;
    this.row = 5;
  }
}
